import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslSpinner } from '@usecapsule/react-components';
import { Heading, CreationStepSubheading, MainContainer, SpinnerContainer } from '../common.js';
export const AwaitingOAuthStep = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SpinnerContainer, { children: _jsx(CpslSpinner, {}) }), _jsxs(MainContainer, { children: [_jsx(Heading, { children: _jsx("span", { children: "Complete Login..." }) }), _jsx(CreationStepSubheading, { children: _jsx("span", { children: "Follow the prompts presented by your browser." }) })] })] }));
};
